
import React from "react";
import Header from "./Header";
import Footer2 from "./Footer2";

const Privacy = () => {
  return (
    <>
      {/* Header Start */}
      <Header />
      {/* Header End */}

      <div className="privacy-main">
        <div className="container">
          <div className="privacy-inner">
            <h1 className="privacy-title"> Privacy Policy</h1>
            <p className="privacy-date">Effective Date: 16/10/2025</p>
            <p className="privacy-intro">
              vvdesigns values your privacy. This Privacy Policy outlines how we
              collect, use, disclose, and safeguard your information when you
              visit our website <strong>vvdesign.in</strong>.
            </p>

            <div className="privacy-section">
              <h3>1. Information We Collect</h3>
              <p>We may collect the following types of information:</p>

              <h4>a. Personal Information</h4>
              <ul>
                <li>Name</li>
                <li>Email address</li>
                <li>Phone number</li>
                <li>Billing and shipping address</li>
                <li>
                  Payment information (processed securely through third-party
                  gateways)
                </li>
              </ul>

              <h4>b. Non-Personal Information</h4>
              <ul>
                <li>Browser type</li>
                <li>Device information</li>
                <li>IP address</li>
                <li>
                  Website usage data (via cookies and analytics tools)
                </li>
              </ul>
            </div>

            <div className="privacy-section">
              <h3>2. How We Use Your Information</h3>
              <ul>
                <li>Process and fulfill orders</li>
                <li>Communicate with you about your purchases</li>
                <li>Send promotional emails (with your consent)</li>
                <li>Improve user experience and website functionality</li>
                <li>Comply with legal obligations</li>
              </ul>
            </div>

            <div className="privacy-section">
              <h3>3. Cookies</h3>
              <p>
                We use cookies to personalize your experience and analyze website
                traffic. You can disable cookies in your browser settings, though
                it may affect site functionality.
              </p>
            </div>

            <div className="privacy-section">
              <h3>4. Third-Party Services</h3>
              <p>We may share your information with:</p>
              <ul>
                <li>Payment processors</li>
                <li>Shipping partners</li>
                <li>Analytics tools (e.g., Google Analytics)</li>
                <li>Marketing platforms</li>
              </ul>
              <p>
                These third parties have their own privacy policies, and we
                encourage you to review them.
              </p>
            </div>

            <div className="privacy-section">
              <h3>5. Data Security</h3>
              <p>
                We implement reasonable security measures to protect your data.
                However, no method of transmission over the internet is 100%
                secure.
              </p>
            </div>

            <div className="privacy-section">
              <h3>6. Your Rights</h3>
              <ul>
                <li>Access, update, or delete your personal data</li>
                <li>Opt-out of marketing emails</li>
                <li>Request data portability</li>
              </ul>
              <p>
                Contact us at{" "}
                <a
                  href="https://mail.google.com/mail/?view=cm&fs=1&to=vvdesign.64@gmail.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 hover:underline"
                >
                  vvdesign.64@gmail.com
                </a>{" "}
                to exercise your rights.
              </p>
            </div>

            <div className="privacy-section">
              <h3>7. Changes to This Policy</h3>
              <p>
                We reserve the right to modify this Privacy Policy at any time.
                Updates will be posted on this page with a new effective date.
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer2 />
    </>
  );
};

export default Privacy;
